
<template>
  <div>
    <loader :loading="loading"></loader>
    <row12 v-if="jobs.length > 0">
      <jobs @refresh="loadJobs" :jobs="jobs" :message="$t('auto_t.message')"></jobs>
    </row12>
    <row>
      <col4>
        <filter-tree
          :title="$t('auto_t.filter_title')"
          :initial_filter="defaultFilters"
          :max_results="false"
          :show_limit="false"
          :show_button="false"
          @update="onFilterUpdate"
        ></filter-tree>
      </col4>
      <col8>
        <p class="text-medium-emphasis mb-4">{{ $t('auto_t.filter_hint') }}</p>
        <primary-button
          v-if="running_jobs.length === 0"
          :label="$t('auto_t.btn_start')"
          @pressed="start_remove_duplicates_job"
        ></primary-button>
      </col8>
    </row>
  </div>
</template>

<script>

import Loader from "@/components/layout/loader.vue";
import Row12 from "@/components/layout/Row12.vue";
import Row from "@/components/layout/Row.vue";
import Col4 from "@/components/layout/Col4.vue";
import Col8 from "@/components/layout/Col8.vue";
import Jobs from "@/components/Jobs.vue";
import PrimaryButton from "@/components/form/PrimaryButton.vue";
import FilterTree from "@/components/asset_filter/FilterTree.vue";
import {
  DEFAULT_REMOVE_DUPLICATES_FILTER,
  buildRemoveDuplicatesDescription,
} from "@/components/auto/noDuplicatesJobUtils";

export default {
  name: "NoDuplicates",
  components: {
    PrimaryButton,
    Jobs,
    Row12,
    Row,
    Col4,
    Col8,
    Loader,
    FilterTree,
  },
  data() {
    return {
      jobs: [],
      loading: true,
      task: 'remove_duplicates',
      defaultFilters: DEFAULT_REMOVE_DUPLICATES_FILTER.map((f) => ({ ...f })),
      filters: DEFAULT_REMOVE_DUPLICATES_FILTER.map((f) => ({ ...f })),
    }
  },
  computed: {
    running_jobs() {
      return this.jobs.filter(job => !job.processed);
    }
  },
  methods: {
    onFilterUpdate(filters) {
      this.filters = filters == null ? [] : filters;
    },
    async start_remove_duplicates_job() {
      this.loading = true;
      const description = buildRemoveDuplicatesDescription(this.filters);
      await this.$api.job.add_job(this.task, description);
      await this.$store.dispatch('snackbars/add_success_snack', 'Remove duplicates job added')
      this.loadJobs();
    },
    async loadJobs() {
      let jobs = await this.$api.job.get_active_jobs(this.task)
      this.jobs = jobs;
      this.loading = false;
    },
  },
  mounted() {
    this.loadJobs();
  },
}
</script>

<style scoped>

</style>
